import { Component, inject, signal, input, computed } from '@angular/core';
import { CommonModule } from '@angular/common';
import { StateService } from '../../../core/services/state-management/state.service';
import { ConsoleViewComponent } from '../console-view/console-view.component';
import { StateViewComponent } from '../state-view/state-view.component';
import { TimelineViewComponent } from '../timeline-view/timeline-view.component';
import { DbViewerComponent } from '../db-viewer/db-viewer.component';

@Component({
  selector: 'app-dev-tools-panel',
  standalone: true,
  imports: [CommonModule, ConsoleViewComponent, StateViewComponent, TimelineViewComponent, DbViewerComponent],
  templateUrl: './dev-tools-panel.component.html',
  styleUrl: './dev-tools-panel.component.scss',
})
export class DevToolsPanelComponent {
  private readonly stateService = inject(StateService);

  readonly tabs = ['Console', 'Timeline', 'State', 'Linting', 'Performance', 'Database'] as const;
  activeTab = signal<string>('Console');

  // Input: Available height from parent draggable component
  availableHeight = input<number>(600); // Default fallback

  // Computed height for child components (available height - tab bar - offset)
  childContentHeight = computed(() => {
    return this.availableHeight() - 20;
  });

  // Get state for State tab
  state = this.stateService.getState();
}